import { makeCancellableAPIRequest } from "./index";

const CIConfigAPI = {
  getCIConfigJob(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/ci-job/config",
      {
        params
      }
    )
  },
  saveCIConfigJob(data, method) {
    return makeCancellableAPIRequest(
      method,
      "/api/ci-job/config",
      {
        data
      }
    )
  },
  deleteCIConfigJob(id) {
    return makeCancellableAPIRequest(
      "DELETE",
      "/api/ci-job/config/" + id
    )
  },
  triggerCIConfigJob(id) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/ci-job/trigger/" + id
    )
  }
}

export default CIConfigAPI;